import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Копіювання з підтвердженням на місці (UIUX patterns/confirmations): текст іде в буфер обміну, а `copied` тримається 1,6 с
 * («✓ Скопійовано», «Посилання скопійовано ✓») без окремого сповіщення.
 */
export function useCopyFeedback(ms = 1600): { copied: boolean; copy: (text: string) => void } {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
  const copy = useCallback((text: string) => {
    void navigator.clipboard?.writeText(text).catch(() => undefined);
    setCopied(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), ms);
  }, [ms]);
  return { copied, copy };
}
